function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5097 8.50885V5.33328C25.5097 4.96495 25.1989 4.66672 24.8157 4.66672H22.0402C22.0402 2.08895 19.8661 0 17.1833 0C14.5007 0 12.3264 2.08895 12.3264 4.66672C12.3264 6.50751 10.773 7.99983 8.8571 7.99983C6.94105 7.99983 5.38767 6.50751 5.38767 4.66672V4H4V4.66672C4 7.24416 6.17452 9.33311 8.8571 9.33311C11.5397 9.33311 13.714 7.24416 13.714 4.66672C13.714 2.82577 15.2672 1.33328 17.1833 1.33328C19.0993 1.33328 20.6526 2.82577 20.6526 4.66672H17.877C17.4939 4.66672 17.1833 4.96495 17.1833 5.33328V8.50885C9.06415 10.5227 3.76985 18.0234 4.8268 26.0164C5.88358 34.0088 12.9609 40 21.3465 40C29.7321 40 36.8094 34.0088 37.866 26.0164C38.9229 18.0234 33.6286 10.5227 25.5097 8.50885ZM21.3465 38.6662C13.5629 38.6649 7.02703 33.0374 6.17539 25.6036C5.32444 18.1701 10.4306 11.3119 18.0276 9.68441C18.345 9.61666 18.571 9.3463 18.571 9.03371V6H24.1218V9.03371C24.1218 9.3463 24.3478 9.61666 24.6653 9.68441C32.2621 11.3119 37.3685 18.1701 36.5174 25.6036C35.6661 33.0374 29.13 38.6649 21.3465 38.6662Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.01846 0H5.61763V2H4.01846V0Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.0186157 4.33328H2.41868V5.66673H0.0186157V4.33328Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.2186 4.33328H9.61865V5.66673H7.2186V4.33328Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M0.252625 2.13785L1.38396 1.19526L2.98414 2.52854L1.8526 3.4713L0.252625 2.13785Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.65305 2.52854L8.25262 1.19526L9.38376 2.13835L7.78438 3.4713L6.65305 2.52854Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M1.27823 7.86166L2.8782 6.52855L4.00934 7.47131L2.40956 8.80459L1.27823 7.86166Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2598 23.333H18.5655C17.2401 23.333 16.1654 22.4375 16.1654 21.333C16.1654 20.2287 17.2401 19.333 18.5655 19.333H25.7128V17.9999H21.7125V16.6666H20.1126V17.9999H18.5655C16.3563 17.9999 14.5654 19.4922 14.5654 21.333C14.5654 23.174 16.3563 24.6664 18.5655 24.6664H23.2598C24.5854 24.6664 25.6599 25.562 25.6599 26.6665C25.6599 27.7708 24.5854 28.6665 23.2598 28.6665H16.1125V29.9997H20.1126V31.333H21.7125V29.9997H23.2598C25.469 29.9997 27.2597 28.5072 27.2597 26.6665C27.2597 24.8255 25.469 23.333 23.2598 23.333Z",
  fill: "white"
});

function SvgDebt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebt);
export default __webpack_public_path__ + "static/media/debt.637e83f7.svg";
export { ForwardRef as ReactComponent };